module.exports = __webpack_public_path__ + "static/coming_soon-a1471d23f967da05370ace3902ce87d7.svg";